import React from "react";
import { Loader2 } from "lucide-react";

const tone = (v) => (v >= 75 ? "text-emerald-300 bg-emerald-500/15 border-emerald-500/40"
  : v >= 55 ? "text-cyan-300 bg-cyan-500/10 border-cyan-500/30"
  : v >= 40 ? "text-amber-300 bg-amber-500/10 border-amber-500/30"
  : "text-red-300 bg-red-500/10 border-red-500/30");

export const ScoreChip = ({ value, kind, testid }) => (
  <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-mono font-bold text-[11px] ${tone(value)}`} data-testid={testid}>
    <span className="font-sans font-semibold opacity-70">{kind}</span>{value}
  </span>
);

const tip = (s) => [
  s.label,
  `Growth ${s.growth} (base ${s.base_growth}${s.growth_adj ? `, GPT ${s.growth_adj > 0 ? "+" : ""}${s.growth_adj}` : ""})`,
  `Investissement ${s.invest} (base ${s.base_invest}${s.invest_adj ? `, GPT ${s.invest_adj > 0 ? "+" : ""}${s.invest_adj}` : ""})`,
  s.why,
].filter(Boolean).join("\n");

export const DualScore = ({ s, loading, ticker, compact }) => {
  if (!s) {
    return loading
      ? <Loader2 className="w-3.5 h-3.5 animate-spin text-slate-500" data-testid={`dual-loading-${ticker}`} />
      : <span className="text-slate-600">—</span>;
  }
  return (
    <span className="inline-flex flex-wrap items-center gap-1" title={tip(s)} data-testid={`dual-${ticker}`}>
      <ScoreChip value={s.growth} kind="G" testid={`dual-growth-${ticker}`} />
      <ScoreChip value={s.invest} kind="I" testid={`dual-invest-${ticker}`} />
      {!compact && <span className="text-[10px] text-slate-400">{s.label}</span>}
    </span>
  );
};
